import type { HubPersonasMap, FolderIdToHubPersonaIdsMap } from '../../appstate';
import { HubPersona, makeHubPersonaId, Person, PersonType } from '../../shared';
import type { ContactFolder } from './personaListSelector';

/**
 * Checks if a hub persona is writeable
 * @param hubPersona the given HubPersona
 */
export function isHubPersonaWritable(hubPersona: HubPersona, personasMap: HubPersonasMap): boolean {
    if (!hubPersona) {
        return false;
    }

    switch (hubPersona.type) {
        case PersonType.Person:
            return hubPersona.isReadOnly === false;

        case PersonType.FavoritePerson: {
            if (!hubPersona.personaId) {
                return false;
            }

            // If this favorite is backed by a contact, check isReadOnly from that contact
            const hubPersonaIdForMap = makeHubPersonaId(hubPersona.personaId);
            const favoriteContact = personasMap[hubPersonaIdForMap];

            return favoriteContact && (favoriteContact as Person).isReadOnly === false;
        }
        case PersonType.PrivateDistributionList:
            return true;
        case PersonType.PublicDistributionList:
        case PersonType.Group:
        default:
            return false;
    }
}

export function getPublicFolderForHubPersona(
    hubPersona: HubPersona,
    activeLeftnavItemId: string,
    publicFolders: ContactFolder[],
    folderIdToHubPersonaIdsMap: FolderIdToHubPersonaIdsMap
): ContactFolder {
    if (!hubPersona) {
        // If there is no current hubPersona, then the folders are empty, and we have to check the active left nav item
        return publicFolders && publicFolders.find(folder => folder.id === activeLeftnavItemId);
    }

    let currentFolderId = undefined;
    for (let folderId of Object.keys(folderIdToHubPersonaIdsMap)) {
        if (
            folderIdToHubPersonaIdsMap[folderId] &&
            folderIdToHubPersonaIdsMap[folderId].find(
                hubPersonaId => hubPersonaId === hubPersona.hubPersonaId
            )
        ) {
            currentFolderId = folderId;
            // Contacts in public folders are not linked, so we don't have to worry about multiple folders
            break;
        }
    }

    return (
        currentFolderId &&
        publicFolders &&
        publicFolders.find(folder => folder.id === currentFolderId)
    );
}
